import { Navigate, useLocation, useParams } from 'react-router-dom';
import { CALENDAR_VIEW_FROM_SLUG } from '../routes/slugs';

/**
 * Los links que apuntan a la Agenda de la WEB (`/calendar`, `/calendar/semanal`…: notificaciones ya enviadas, mails, el
 * botón "ir al calendario" de Pacientes) llevan a la Agenda de la app, que es `/calendar` (la vista sale del slug: `/calendar/semanal` → `/calendar?view=week`). La vista sale del slug y el resto del
 * query (`?session=`, `?date=`, `?process=`, `?openForPatient=`…) se conserva. `/calendar/time-off` no es una vista.
 */
export function PwaCalendarAlias() {
  const { view: slug } = useParams<{ view?: string }>();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const view = slug ? CALENDAR_VIEW_FROM_SLUG[slug] : undefined;
  if (view) params.set('view', view);
  const q = params.toString();
  return <Navigate to={`/calendar${q ? `?${q}` : ''}`} replace />;
}
